export default "__VITE_ASSET__Bjk5j5cV__"